// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/tailwindcss/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-profile {
  min-width: 0;
  flex-shrink: 0;
  margin-left: 8px;
}

@media (max-width: 520px) {
  .header-profile .profile-role {
    display: none;
  }
}

.list-page-body {
  margin-top: 74px;
  height: calc(100vh - 74px);
  overflow: hidden;
  min-width: 0;
}

.policies-container,
.statement-container,
.commission-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 8px 12px 12px;
  box-sizing: border-box;
  overflow: hidden;
}

.commission-container {
  width: calc(100% - 18%);
  margin-left: 18%;
}

.list-toolbar {
  width: 100% !important;
  max-width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap !important;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-sizing: border-box;
}

.list-title {
  margin: 0;
  color: black;
  font-size: 24px;
  font-weight: 700;
}

.list-toolbar-actions {
  width: min(245px, 100%) !important;
  height: auto !important;
  margin-top: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.list-toolbar-actions .MuiTextField-root,
.list-toolbar-actions .MuiButton-root,
.list-toolbar-actions .MuiFormControl-root,
.list-toolbar-actions .MuiInputBase-root,
.list-toolbar-actions .MuiOutlinedInput-root {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.list-grid {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  height: auto !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.list-grid .MuiTableContainer-root {
  flex: 1 1 auto;
  min-height: 0;
  width: auto !important;
  max-width: 100%;
  margin: 8px 0 0 !important;
  overflow: auto;
}

.list-grid table {
  width: max-content;
  min-width: 100%;
}

.list-grid th,
.list-grid td {
  white-space: nowrap;
  font-size: 13px;
}

@media (max-width: 1024px) {
  .commission-container {
    width: calc(100% - 28%);
    margin-left: 28%;
  }
}

@media (max-width: 600px) {
  .policies-container,
  .tools-container,
  .carriers-container,
  .statement-container,
  .commission-container,
  .support-page,
  .agents-container,
  .tutorials-container {
    margin-left: 180px !important;
    width: calc(100% - 180px) !important;
  }
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.notification-popUp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notification-container {
  background: white;
  width: 70% !important;
  height: 80%;
  border-radius: 8px;
  position: relative;
  left: 0;
  right: 0;
  padding: 10px 30px 10px 30px;
  display: flex;
  align-items: center;
  flex-direction: column !important;
  justify-content: center;

  @media screen and (min-width: 1024px) {
    width: 50% !important;
  }
}

.notification-close {
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
}

.notification-content-container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 20px;
  width: 100%;
  height: 80%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.notification-content-container div {
  padding: 7px 20px;
  width: 96%;
  border-radius: 5px;
  cursor: pointer;
}
.notification-content-container .unread {
  background-color: #085e6a;
}
.notification-content-container .read {
  background-color: #8a8787;
}

.notification-content-container div:hover {
  background-color: #1d9eb0;
  transition: all;
  transition-duration: 500ms;
}
.notificationText {
  font-size: 18px;
  color: white;
}

.hide-scrollbar {
  /* &::-webkit-scrollbar {
    display: none;
  } */

  scrollbar-width: 50px !important;

  :-webkit-scrollbar {
    scrollbar-width: 250px !important;
  }

  /* -ms-overflow-style: none; */
}

.deleteButton {
  background-color: #f89522;
  color: #fff;
  padding: 5px 7px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 7px;
}
.readButton {
  background-color: rgb(12, 5, 68);
  color: #fff;
  padding: 5px 7px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 7px;
  margin-right: 7px;
}

.readButton.unreadbtn {
  background-color: green;
}

.clearBtn {
  background-color: #f89522;
  align-self: flex-end;
  margin-top: 10px;
  padding: 7px 10px;
  border-radius: 7px;
  font-size: 17px;
  color: #fff;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;;;;;EAKE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;;;IAQE,6BAA6B;IAC7B,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;;EAEvB;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;;KAEG;;EAEH,gCAAgC;;EAEhC;IACE,iCAAiC;EACnC;;EAEA,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":["@import \"tailwindcss\";\n.header-profile {\n  min-width: 0;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n@media (max-width: 520px) {\n  .header-profile .profile-role {\n    display: none;\n  }\n}\n\n.list-page-body {\n  margin-top: 74px;\n  height: calc(100vh - 74px);\n  overflow: hidden;\n  min-width: 0;\n}\n\n.policies-container,\n.statement-container,\n.commission-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  padding: 8px 12px 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.commission-container {\n  width: calc(100% - 18%);\n  margin-left: 18%;\n}\n\n.list-toolbar {\n  width: 100% !important;\n  max-width: 100%;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap !important;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  box-sizing: border-box;\n}\n\n.list-title {\n  margin: 0;\n  color: black;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.list-toolbar-actions {\n  width: min(245px, 100%) !important;\n  height: auto !important;\n  margin-top: 0 !important;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.list-toolbar-actions .MuiTextField-root,\n.list-toolbar-actions .MuiButton-root,\n.list-toolbar-actions .MuiFormControl-root,\n.list-toolbar-actions .MuiInputBase-root,\n.list-toolbar-actions .MuiOutlinedInput-root {\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box;\n}\n\n.list-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  height: auto !important;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.list-grid .MuiTableContainer-root {\n  flex: 1 1 auto;\n  min-height: 0;\n  width: auto !important;\n  max-width: 100%;\n  margin: 8px 0 0 !important;\n  overflow: auto;\n}\n\n.list-grid table {\n  width: max-content;\n  min-width: 100%;\n}\n\n.list-grid th,\n.list-grid td {\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n@media (max-width: 1024px) {\n  .commission-container {\n    width: calc(100% - 28%);\n    margin-left: 28%;\n  }\n}\n\n@media (max-width: 600px) {\n  .policies-container,\n  .tools-container,\n  .carriers-container,\n  .statement-container,\n  .commission-container,\n  .support-page,\n  .agents-container,\n  .tutorials-container {\n    margin-left: 180px !important;\n    width: calc(100% - 180px) !important;\n  }\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.notification-popUp {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 20;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.notification-container {\n  background: white;\n  width: 70% !important;\n  height: 80%;\n  border-radius: 8px;\n  position: relative;\n  left: 0;\n  right: 0;\n  padding: 10px 30px 10px 30px;\n  display: flex;\n  align-items: center;\n  flex-direction: column !important;\n  justify-content: center;\n\n  @media screen and (min-width: 1024px) {\n    width: 50% !important;\n  }\n}\n\n.notification-close {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  cursor: pointer;\n}\n\n.notification-content-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  gap: 20px;\n  width: 100%;\n  height: 80%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.notification-content-container div {\n  padding: 7px 20px;\n  width: 96%;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.notification-content-container .unread {\n  background-color: #085e6a;\n}\n.notification-content-container .read {\n  background-color: #8a8787;\n}\n\n.notification-content-container div:hover {\n  background-color: #1d9eb0;\n  transition: all;\n  transition-duration: 500ms;\n}\n.notificationText {\n  font-size: 18px;\n  color: white;\n}\n\n.hide-scrollbar {\n  /* &::-webkit-scrollbar {\n    display: none;\n  } */\n\n  scrollbar-width: 50px !important;\n\n  :-webkit-scrollbar {\n    scrollbar-width: 250px !important;\n  }\n\n  /* -ms-overflow-style: none; */\n}\n\n.deleteButton {\n  background-color: #f89522;\n  color: #fff;\n  padding: 5px 7px;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 7px;\n}\n.readButton {\n  background-color: rgb(12, 5, 68);\n  color: #fff;\n  padding: 5px 7px;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 7px;\n  margin-right: 7px;\n}\n\n.readButton.unreadbtn {\n  background-color: green;\n}\n\n.clearBtn {\n  background-color: #f89522;\n  align-self: flex-end;\n  margin-top: 10px;\n  padding: 7px 10px;\n  border-radius: 7px;\n  font-size: 17px;\n  color: #fff;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
